import { FC } from 'react';

interface Props {
  className?: string;
  height?: number;
  id: string;
}

export const SpotifyPlayer: FC<Props> = ({
  className = '',
  height = 442,
  id,
}) => (
  <iframe
    allow="clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    allowFullScreen={false}
    className={className}
    height={height}
    loading="lazy"
    src={`https://open.spotify.com/embed/playlist/${id}?theme=0`}
    title={id}
    width="100%"
  />
);
